<div class="app__container mt-10 flex flex-col gap-6">
	<h2 class="text-left text-primary-900">Mi Perfil</h2>

	<div class="flex flex-row gap-6">
		<activar-tabs [tabs]="tabs()" [vertical]="true" [activeTab]="activeTabIndex()" (switch)="setCurrentTab($event)" />

		<div class="w-full">
			@if (currentTab() === tabNames.Info) {
				@if (profileLoading()) {
					<p>Cargando perfil...</p>
				} @else if (profile(); as profile) {
					<app-profile-info [profile]="profile" />
				} @else {
					<div class="flex flex-col gap-3 items-start">
						<p>No se pudo cargar el perfil.</p>
						<activar-button text="Reintentar" fill="out" color="primary" (click)="store.loadProfile()" />
					</div>
				}
			} @else if (currentTab() === tabNames.Sessions) {
				<app-profile-sessions
					[sessions]="sessions()"
					[loading]="sessionsLoading()"
					[sessionsError]="sessionsError()"
					[canRevokeOthers]="canRevokeOthers()"
					(revokeOne)="revokeOne($event)"
					(revokeAll)="revokeAll()"
					(retry)="retrySessions()" />
			} @else if (currentTab() === tabNames.Security) {
				<app-profile-security />
			} @else if (currentTab() === tabNames.ApiKeys && isSuperadmin()) {
				<app-profile-api-keys />
			}
		</div>
	</div>
</div>
